import { useContext } from "react";
import { AppContext } from "../AppContext";
import { ReactComponent as ArrakisLogo } from "../assets/images/arrakis-logo.svg";

export const Header = () => {
  const { isDarkMode, toggleTheme } = useContext(AppContext);
  return (
    <header className="sticky top-0 z-40 w-full backdrop-blur border-b lg:border-slate-900/10 dark:border-slate-50/[0.06] bg-white/20 dark:bg-transparent text-black dark:text-white">
      <div className="px-4 py-3 mt-1 mb-2 flex justify-between">
        <ArrakisLogo />
        <button onClick={toggleTheme} className="py-0">
          {isDarkMode ? "☼" : "☾"}
        </button>
      </div>
    </header>
  );
};
